var template = require('./paginator.tpl.html');

angular.module('directives.paginator', [])
  .directive('paginator', ["$parse", function ($parse) {
    return {
      restrict: 'E',
      scope: {
        $page: '=pageModel',
        callback: '&onNavigate'
      },
      template: template,
      link: function (scope, element, attrs) {

        var paginate = function (offset) {
          scope.$apply(function () {
            scope.callback({$offset: offset});
          });
        };

        element.on('click', '.next', function () {
          paginate(scope.$page.offset + scope.$page.limit);
        });
        element.on('click', '.prev', function () {
          paginate(scope.$page.offset - scope.$page.limit);
        });
      }
    }
  }]);



// WEBPACK FOOTER //
// ./client/src/common/directives/paginator.js